import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
// import "./plugins/vconsole";
// eslint-disable-next-line no-unused-vars
// import $ from "jquery";
Vue.config.productionTip = false;
import "./style/base/utilities.less"; //全局样式
import "animate.css"; //animate.css
import lrz from "lrz";
import browser from "./plugins/browser"; //plugin-获取浏览器环境
import loading from "./plugins/loading/loading"; //plugin-自定义loading组件
import toast from "./plugins/toast/toast"; //plugin-自定义toast
import Page from "./plugins/page"; //plugin-可设置document的title
import upfiled from "./plugins/file"; //指令 - 上传文件指令
import autotextauto from "./plugins/auto-textarea"; //指令 - 调整输入框高度
import scroll from "@/plugins/scroll/index";
import VueImageSwipe from "vue-image-swipe";
import "vue-image-swipe/dist/vue-image-swipe.css";
import axios from "axios";
Vue.prototype.$axios = axios;
Vue.use(VueImageSwipe);
Vue.use(autotextauto);
Vue.use(loading, {});
Vue.use(browser, {});
Vue.use(toast, {});
Vue.use(Page);
Vue.use(scroll);
Vue.prototype.lrz = lrz;
Vue.use(upfiled, {});
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
